(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('PaginationService', ['$stateParams', 'HelperService', '$filter', PaginationServiceFn]);

    // service to handle overview specific things like pagination and filtering
    function PaginationServiceFn($stateParams, HelperService, $filter) {
        
        // service class
        var paginationService = function (elements, itemsPerPage = 15) {
            // data object
            var data = {
                // pagination data
                pagination: {
                    currentPage: 1,
                    itemsPerPage: itemsPerPage
                },

                // filter for show-all
                showAll: false, // default

                items: [], // unfiltered original item array
                filteredItems: [], // filtered/paged items array
                results: [], // result list (filtered and paginated)

                total: 0 // counter on items currently selected/filtered 
            };


            // calculate filtered array (pagination)
            function paginate() {
                // set new result list
                data.results = HelperService.paginate(data.filteredItems, data.pagination.currentPage, data.pagination.itemsPerPage);
                data.total = data.filteredItems.length;
            } // paginate


            /* init */
            function init(elements) {
                //clean
                data.pagination.currentPage = 1;
                data.pagination.itemsPerPage = itemsPerPage;
                // original items
                data.items = elements;
                // total items
                data.total = data.items.length;
                // filtered items (filtering happens outside)
                data.filteredItems = data.items;

                // set show-all-filter-checkbox
                if ($stateParams.all && ($stateParams.all === 'true' || $stateParams.all === true)) {
                    data.showAll = true;
                } //if
                else {
                    data.showAll = false;
                } // else

                // calculate for pagination
                paginate();
            } // init


            function replace(itemToReplace) {
                var existingItem = data.items.filter(function(item) {
                    return item.id === itemToReplace.id;
                })[0];

                // item not found => just add it
                if (!existingItem) {
                    add(itemToReplace);                
                }

                var idx = data.items.indexOf(existingItem);
                if (idx >= 0) {
                    data.items.splice(idx, 1, itemToReplace)
                }
            }

            /* add new item to list */
            function add(item) {
                data.items.unshift(item); // to begin
                data.filteredItems = data.items;
                // paginate
                paginate();
            }

            // remove item by id
            function remove(item) {
                var i;
                var len = data.items.length; // performance boost

                var removed = [];

                for (i = 0; i < len; i++) {
                    if (data.items[i].id && data.items[i].id === item.id) {
                        removed = data.items.splice(i, 1);
                        break;
                    } //if
                } //for
                data.filteredItems = data.items;
                paginate();
                return removed && removed.length > 0 ? removed[0] : null;
            } // remove

            // clean
            function clean() {
                data.items = [];
                data.filteredItems = [];
                data.results = [];
            } // clean

            // init
            init(elements);

            this.data = data;
            this.paginate = paginate;
            this.add = add;
            this.remove = remove;
            this.init = init;
            this.clean = clean;
            this.replace = replace;
        };

        return paginationService;      
    }
})();